import cx from "classnames";

import styles from "../../styles/SearchIcon.module.less";

type SearchIconProps = {
  isActive?: boolean;
  onClick?: () => void;
  className?: string;
};

const SearchIcon = ({ isActive, onClick, className }: SearchIconProps) => {
  const content = (
    <>
      <div className={styles.lineMain} />
      <div className={styles.lineClose} />
      <div className={styles.circle} />
      <span className={styles.visuallyHidden}>Search</span>
    </>
  );

  if (onClick) {
    return (
      <button
        className={cx(styles.icon, isActive && styles.active, className)}
        type="button"
        onClick={onClick}
      >
        {content}
        <span className={styles.visuallyHidden}>Search</span>
      </button>
    );
  }

  return <div className={cx(styles.icon, isActive && styles.active, className)}>{content}</div>;
};

export default SearchIcon;
